import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-redirect-to-portal',
  templateUrl: './redirect-to-portal.component.html',
  styleUrls: ['./redirect-to-portal.component.scss']
})
export class RedirectToPortalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.location.href = environment.portalRedirect
  }

}
